<div class="relative rounded-lg border border-sky-100 bg-sky-50/70 px-4 py-3.5">
  <span
    class="absolute right-4 top-3.5 inline-flex items-center gap-1.5 rounded-md
           bg-sky-100 px-2 py-1 text-[10px] font-semibold uppercase tracking-wider
           text-sky-700"
  >
    <svg viewBox="0 0 16 16" class="size-3" fill="none" aria-hidden="true">
      <rect x="3" y="2" width="10" height="12" rx="1.5" stroke="currentColor" stroke-width="1.3" />
      <path d="M5.5 5.5h5M5.5 8h5M5.5 10.5h2.5" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" />
    </svg>
    Calculated
  </span>

  <p class="text-xs text-slate-500">{{ label() }}</p>
  <p class="mt-1 text-[26px] font-bold leading-tight tracking-tight text-slate-900">
    {{ value() }}
  </p>
  @if (derivation()) {
    <p class="mt-1 text-xs text-slate-500">{{ derivation() }}</p>
  }
</div>
